export default __webpack_public_path__ + "static/media/FECHAS_01.ffc28e4b.png";